import isToday from 'date-fns/is_today';

const key = 'PowerReviewsModeration.CompletedCount';
const defaultObject = {};

const getTodayCount = () => {
  const { date = Date.now(), count: v } =
    JSON.parse(global.localStorage.getItem(key)) || defaultObject;

  return {
    date,
    count: Boolean(v) && isToday(date) ? Number(v) || 0 : 0,
  };
};

const saveTodayCount = count => {
  try {
    const objToSet = {
      date: Date.now(),
      count,
    };

    global.localStorage.setItem(key, JSON.stringify(objToSet));
  } catch (err) {
    console.error(err);
  }
};

const __exports__ = {
  getTodayCount,
  saveTodayCount,
};

export default __exports__;



// WEBPACK FOOTER //
// ./src/pages/moderation/moderate/moderateStorage.js